import { createContext } from 'react';
import type { GlobalContextValue } from '../types';

// Kept out of GlobalContext.tsx. That file exports the provider component,
// and a context object beside it makes Vite refuse Fast Refresh.
export const GlobalContext = createContext<GlobalContextValue>(
  {} as GlobalContextValue,
);
